<template>
  <div class="qrcode-card">
    <div class="qrc-image" :style="'background-image: url(\''+qrcodeSrc+'\')'"></div>
    <p>扫描二维码，查看手机版</p>
  </div>
</template>
<script>
  import envConfig from '@/config/env.js'
  export default {
    props: {
      cardData: Object
    },
    data(){
      return {};
    },
    computed: {
      qrcodeSrc(){
        return envConfig.generatorQR + encodeURIComponent(envConfig.PackH5Url + this.cardData.code)
      }
    }
  }
</script>
<style rel="stylesheet/less" lang="less" scoped>
  .qrcode-card {
    .qrc-image {
      width: 80%;
      padding-bottom: 80%;
      margin: auto;
      background: center center no-repeat;
      background-size: contain;
      margin-top: 0.5rem;
      margin-bottom: 0.5rem;
    }
    p {
      font-size: 13px;
      color: #ffffff;
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// qrcode-card.vue?0bfb21bb